module.exports = __webpack_public_path__ + "static/media/grin-tongue-wink-alt.844de9e5.svg";